module.exports = __webpack_public_path__ + "img/explosion-hit.5f7207cf.png";